import {mccSearch} from "../mccSearch/mccHooks";
import {find, pick} from "lodash";
import {message} from "antd";

export async function importAdSellerData({data, controller, mcc, mccLogin, wizard}) {
    const {advertiser: asAdv={}, presentation={}} = data;
    let advertiser, salesSheet, specAd, template;

    if (asAdv.id) {
        const accountReference = 'PU-AV-' + asAdv.id;  // Not editable yet so should be there...
        advertiser = await controller.findAdvertiser({accountReference});
        if (!advertiser) {
            advertiser = await controller.findAdvertiser({name: asAdv.name});
            // todo set accountRef?
        }

        if (!advertiser) {
            const {name, address, phone, web} = asAdv;
            const newAdv = {
                name,
                accountReference,
                company: {
                    name,
                    phone,
                    web,
                    address1: address.street,
                    ...pick(address, 'city', 'state', 'zip')
                }
            };
            try {
                advertiser = await controller.createAdvertiser(newAdv);
            } catch (e) {
                console.log(e);
                // todo -170 name already exists
                message.warn("Failed to create advertiser: " + e.message);
            }
        }

        if (advertiser) {
            advertiser.adSeller = data
        }
    }

    if (presentation.id) {
        const {id, ad_id: metroSpecAd, name} = presentation;
        // Ad Seller don't send a name yet

        if (advertiser) {
            const jobNumber = 'AS-PR-' + id;
            const where = {
                advertiserId: advertiser.id,
                jobNumber
            };
            salesSheet = await controller.findSalesSheet(where);
            if (!salesSheet) {
                const newSs = {
                    jobNumber,
                    name: name || jobNumber
                };
                salesSheet = await controller.createSalesSheet(newSs, advertiser);
            }
        }

        if (metroSpecAd) {

            if (salesSheet) {
                specAd = find(salesSheet.specAds, {metroSpecAd});
                // todo ? Check Ad contents match
            }

            if (!specAd) {
                // todo ?autosave spec Ad - tricky - just let them do it
                template = await getTemplate(presentation.ad_id, mcc, mccLogin, wizard);
                if (!template) {
                    message.error('Template not found: ' + presentation.ad_id);
                }
            }
        }
    }

    wizard.isAdSeller = true;

    return {salesSheet, specAd, template, advertiser};
}


//todo ?just use wizard.getAsset
async function getTemplate(name, mcc, mccLogin, wizard)
{
    const queryInfo = {
        filters:{
            file_base: [name],
            file_ext: ['qxd','qxp','psd','jpg'],
            has_miad: ['has miad'],
            color: ['color'],
            metro_type: ['spec ad'],
        },
        pager: {order: 'latest'}
    };

    const results = await mccSearch({mcc, mccLogin, queryInfo, wizard});
    return results.total >0 ? results.records[0] : null;
}